"use client";
import Gatekeeper from ".";

import { useEffect } from "react";

export const GatekeeperClient = (
  parameters: Parameters<typeof Gatekeeper.init>[0],
) => {
  useEffect(() => {
    void Gatekeeper.init(parameters);
  }, []);
  return null;
};
